import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import './styles.css';
import UserInput from './components/UserInput';
import Footer from './components/Footer';

function App() {
  const [chatMessages, setChatMessages] = useState(() => {
    const stored = localStorage.getItem('chatMessages');
    return stored ? JSON.parse(stored) : [];
  });

  const [userId, setUserId] = useState(() => {
    const storedId = localStorage.getItem('userId');
    return storedId || '';
  });

  const [isLoading, setIsLoading] = useState(false);
  const [loadingDots, setLoadingDots] = useState('');

  useEffect(() => {
    if (!userId) {
      const newUserId = 'user-' + Date.now();
      setUserId(newUserId);
      localStorage.setItem('userId', newUserId);
    }
  }, [userId]);

  useEffect(() => {
    localStorage.setItem('chatMessages', JSON.stringify(chatMessages));
  }, [chatMessages]);

  useEffect(() => {
    if (isLoading) {
      const interval = setInterval(() => {
        setLoadingDots((prev) => (prev.length < 3 ? prev + '.' : ''));
      }, 500);
      return () => clearInterval(interval);
    } else {
      setLoadingDots('');
    }
  }, [isLoading]);

  const sendMessage = async (message) => {
    setChatMessages((prevMessages) => [
      ...prevMessages,
      { sender: 'You', content: message, type: 'text' }
    ]);

    setIsLoading(true);
    setChatMessages((prevMessages) => [
      ...prevMessages,
      { sender: 'Aurora', content: '...', type: 'loading' }
    ]);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': process.env.REACT_APP_API_KEY
        },
        body: JSON.stringify({ message, userId })
      });

      if (!response.ok) {
        throw new Error('Failed to get a response from the server. Please try again.');
      }

      const data = await response.json();
      const aiReply = data.reply;

      setChatMessages((prevMessages) => {
        const updatedMessages = [...prevMessages];
        updatedMessages.pop(); // Remove loading message
        return [...updatedMessages, { sender: 'Aurora', content: aiReply, type: 'mdx' }];
      });

    } catch (error) {
      console.error('Error sending message:', error.message);
      setChatMessages((prevMessages) => {
        const updatedMessages = [...prevMessages];
        updatedMessages.pop(); // Remove loading message
        return [...updatedMessages, { sender: 'Aurora', content: 'Error fetching response. Please try again.', type: 'text' }];
      });
    } finally {
      setIsLoading(false);
    }
  };

  const clearChat = async () => {
    setChatMessages([]);
    localStorage.removeItem('chatMessages');

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': process.env.REACT_APP_API_KEY
        },
        body: JSON.stringify({ userId })
      });

      if (!response.ok) {
        throw new Error('Failed to delete chat history on the server.');
      }
    } catch (error) {
      console.error('Error deleting chat history:', error.message);
    }
  };

  return (
    <div className="App">
      <div className="header">
        <h1 className="flag"><span></span> AuroraAI</h1>
      </div>
      <div className="chat-container">
        <div className="chat-box">
          {chatMessages.map((message, index) => (
            <div key={index} className={`message ${message.sender === 'Aurora' ? 'ai-message' : ''}`}>
              <span className="sender">{message.sender}: </span>
              <div className="content">
                {message.type === 'loading' ? (
                  <span className="loading-animation">{loadingDots}</span>
                ) : message.type === 'mdx' ? (
                  <ReactMarkdown className="markdown-output">{message.content}</ReactMarkdown>
                ) : (
                  <div style={{ whiteSpace: 'pre-wrap' }}>{message.content}</div>
                )}
              </div>
            </div>
          ))}
        </div>
        <div className="input-wrapper">
          <UserInput onSendMessage={sendMessage} onClearChat={clearChat} isLoading={isLoading} />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default App;